import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import CommonAnimatedLoader from '../../components/common/animated/loader';
import { setAnswerCookie } from '../../context/questionnaire';
import { useSite } from '../../hooks/use-site';
import { getLocalizedPath } from '../../helpers/localization-helper';

function QuestionnaireStartConsultationPageComponent() {
  const navigate = useNavigate();
  const { answerHash } = useParams();
  const { locale, region } = useSite();

  useEffect(() => {
    const createAnswer = async () => {
      if (answerHash) {
        setAnswerCookie(answerHash);
      }

      navigate(getLocalizedPath('/questionnaire/onboarding/1', locale, region));
    };

    createAnswer();
  }, [locale]);

  return <CommonAnimatedLoader />;
}

export default QuestionnaireStartConsultationPageComponent;
